"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Import/ImportMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _icons = require('../icons');






/* Screen 2: Import a form, with its two ways in. */
const ImportMenu = ({ onUpload, onScan }) => {
  const anchorRef = _react.useRef(null)
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const close = () => setIsOpen(false)
  const choose = (action) => () => {
    close()
    action()
  }
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('button', {
        ref: anchorRef,
        type: "button",
        className: "blm-btn blm-btn--primary forms-import-btn"  ,
        'aria-haspopup': "menu",
        'aria-expanded': isOpen,
        onClick: () => setIsOpen(was => !was), __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}

        , _react2.default.createElement(_icons.UploadIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 30}} ), "Import a form"

        , _react2.default.createElement(_icons.ChevronDownIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
      )
      ,  isOpen && (
        _react2.default.createElement(_Popover2.default, { anchorRef: anchorRef, align: "right", onClose: close, className: "forms-menu", role: "menu", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
          , _react2.default.createElement('button', { type: "button", role: "menuitem", className: "forms-menu--item", onClick: choose(onUpload), __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
            , _react2.default.createElement('span', { className: "forms-menu--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, _react2.default.createElement(_icons.UploadIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} ))
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
              , _react2.default.createElement('span', { className: "forms-menu--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "Upload a file"  )
              , _react2.default.createElement('span', { className: "forms-menu--sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}, "PDF or a photo of the page"      )
            )
          )
          , _react2.default.createElement('button', { type: "button", role: "menuitem", className: "forms-menu--item", onClick: choose(onScan), __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
            , _react2.default.createElement('span', { className: "forms-menu--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, _react2.default.createElement(_icons.CameraIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 44}} ))
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
              , _react2.default.createElement('span', { className: "forms-menu--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}, "Scan with your phone"   )
              , _react2.default.createElement('span', { className: "forms-menu--sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "Take photos of a paper form with your phone's camera"         )
            )
          )
        )
      )
    )
  )
}

exports. default = ImportMenu
